import BaseRequest from './BaseRequest';

export default class CustomerForms extends BaseRequest {
    /**
     * CustomerForms constructor
     *
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(
        requestMode = 'customer',
        providerId = '',
        customerId = '',
        auth = true,
        fowardRequest = false,
    ) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('CustomerForms');
        this.setEndpoint('customer_forms');
    }

    /**
     * @return {object}
     */
    async getMembershipForms() {
        const listReponse = await this.listAll(20, [], [], '', {
            applicable_to: 'all_memberships',
            no_signup: true,
        });

        return listReponse;
    }
}
